import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";

export const NotificationTag = styled(Chip)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  color: '#777',
  fontSize: '0.9em',
  marginRight: theme.spacing(1)
}));
